import { useState, useEffect } from 'react';
import request from '../../utils/request';
import TableSearch from '../common/TableSearch';
import loader from '../common/loader.gif';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import DeleteAlert from '../common/DeleteAlert';
import PageHeader from '../common/PageHeader';

import {
  Tooltip,
  Divider,
  Box,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Typography,
  useTheme,
  Switch,
  Grid
} from '@mui/material';

import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import SnackbarAlert from '../common/SnackbarAlert';
import { checkPermission } from '../../utils/permission';
import ShowHistoryButton from '../common/ShowHistoryButton';
import NoDataAvailable from '../common/NoDataAvailable';
import Links from '@mui/material/Link';
import TableSearchWithIcon from '../common/TableSearchWithIcon';

const EndoresementSubTypeList = ({ editDatas, showCreateEditForm }) => {
  const [isLoading, setLoading] = useState(true);
  const theme = useTheme();
  const [endoresementSubTypeData, setEndoresementSubTypeData] = useState<any>([]);
  const [offset, setOffset] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState<number>(0);
  interface SearchState {
    text: string;
    triggerId: number;
  }
  const [search, setSearch] = useState<SearchState>({
    text: '',
    triggerId: Date.now(),
  });
  const [deleteopen, setDeleteOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>([]);
  const [endoresementSubTypeCreatePermission, setEndoresementSubTypeCreatePermission] =
    useState(false);
  const [endoresementSubTypeUpdatePermission, setEndoresementSubTypeUpdatePermission] =
    useState(false);
  const [endoresementSubTypeDeletePermission, setendoresementSubTypeDeletePermission] =
    useState(false);

  const handleDeleteOpen = (endorsement) => {
    setDeleteData(endorsement);
    setDeleteOpen(true);
  };

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const handleChangePage = (event, newPage) => {
    setOffset(newPage);
    getendoresementSubTypeData();
  };

  const handleChange = (editDatas, type) => {
    request({
      url: 'endorsement/updateEndoresementSubTypeStatus',
      method: 'post',
      data: {
        id: editDatas.id,
        status: type === 'status_chng' ? !editDatas.status : editDatas.status
      }
    })
      // eslint-disable-next-line
      .then((data) => {
        setTimeout(() => {
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement status updated'
          });
        }, 1000);
        getendoresementSubTypeData();
      })
      .catch(function (err) {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
    getendoresementSubTypeData();
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    setRowsPerPage(+parseInt(event.target.value));
    setOffset(0);
    getendoresementSubTypeData();
  };

  const changeSearch = (searchValue) => {
    console.log(searchValue);
    setOffset(0);
    setSearch(searchValue);
    // getendoresementSubTypeData();
  };

  useEffect(() => {
    getendoresementSubTypeData();
  }, [rowsPerPage, offset, search]);
  const getendoresementSubTypeData = async () => {
    const routeArray = window.location.pathname.split('/');
    request({
      url: 'endorsement/getEndoresementSubTypes',
      method: 'post',
      data: {
        search:search?.text,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: offset,
        limit: rowsPerPage,
      }
    }).then(
      (response) => {
        setEndoresementSubTypeData([]);
        setEndoresementSubTypeData(response['rows']);
        setTotalCount(0);
        setTotalCount(response['count']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const refetchApi = () => {
    getendoresementSubTypeData();
  };

  useEffect(() => {
    checkRolePermission();
    checkUpdateRolePermission();
    checkDeleteRolePermission();
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('EndorsementSubTypes', 'Create').then((permission) => {
      setEndoresementSubTypeCreatePermission(permission);
    });
  };

  const checkUpdateRolePermission = async () => {
    await checkPermission('EndorsementSubTypes', 'Update').then((permission) => {
      setEndoresementSubTypeUpdatePermission(permission);
    });
  };

  const checkDeleteRolePermission = async () => {
    await checkPermission('EndorsementSubTypes', 'Delete').then((permission) => {
      setendoresementSubTypeDeletePermission(permission);
    });
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Card>
        <Grid container mt={1} mb={1} mr={1} ml={1}>

          <Grid item xs={8}>
            <PageHeader
              title={'Endorsement Sub Types'}
              button_text={'Create'}
              showCreateEditForm={showCreateEditForm}
              createPermission={endoresementSubTypeCreatePermission}

            />
          </Grid>


          <Grid item xs={4}>
            <TableSearchWithIcon
              changeSearch={changeSearch}
              deafultSearchValue={search.text}
            />
          </Grid>
        </Grid>

        <Divider />
        {isLoading ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <img
                      alt="loader"
                      src={loader}
                      className="loader"
                      width={100}
                      height={100}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        ) : (
          <TableContainer>
            {endoresementSubTypeData?.length > 0 ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Endorsement Type</TableCell>
                    <TableCell>Endorsement Sub Type</TableCell>
                    <TableCell>Product</TableCell>
                    {endoresementSubTypeUpdatePermission ? (
                      <TableCell>Status</TableCell>
                    ) : null}

                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {endoresementSubTypeData.map((endorsement) => {
                    return (
                      <TableRow hover key={endorsement.id}>
                        <TableCell>
                          {endorsement.type}
                        </TableCell>
                        <TableCell>
                          {endorsement.name}
                        </TableCell>
                        <TableCell>
                          {endorsement?.policyProduct?.name}
                        </TableCell>
                        {endoresementSubTypeUpdatePermission ? (
                          <TableCell align="left">
                            <Switch
                              checked={endorsement.status}
                              inputProps={{ 'aria-label': 'controlled' }}
                              onChange={() =>
                                handleChange(endorsement, 'status_chng')
                              }
                            />
                          </TableCell>
                        ) : null}

                        <TableCell>
                          {endoresementSubTypeUpdatePermission ? (
                            <Tooltip title="Edit endorsement" arrow>
                              <IconButton
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.primary.lighter
                                  },
                                  color: theme.palette.primary.main
                                }}
                                color="inherit"
                                size="small"
                                onClick={() => editDatas(endorsement)}
                              >
                                <EditTwoToneIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          ) : null}


                          {endoresementSubTypeDeletePermission ? (
                            <Tooltip title={`Delete Endorsement Sub Type`} arrow>
                              <IconButton
                                sx={{
                                  '&:hover': {
                                    background: theme.colors.error.lighter
                                  },
                                  color: theme.palette.error.main
                                }}
                                color="inherit"
                                size="small"
                                onClick={() => handleDeleteOpen(endorsement)}
                              >
                                <DeleteTwoToneIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : (
              <NoDataAvailable />
            )}
          </TableContainer>
        )}

        <DeleteAlert
          pageContent={'endorsement'}
          deleteopen={deleteopen}
          deleteName={deleteData.name}
          deleteData={deleteData}
          refetchApi={refetchApi}
          setDeleteOpen={setDeleteOpen}
          apiUrl={'endorsement/endoresementSubType/' + deleteData.id}
        />

        <Box p={2}>
          <TablePagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={offset}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Card>
    </>
  );
};

export default EndoresementSubTypeList;
